module.exports = __webpack_public_path__ + "static/media/stats-1.c2ae9d1a.svg";